import React, { ReactText, useState } from "react"
import ReactModal from "react-modal"
// import { useMediaQuery } from "react-responsive"
import tw, { styled, css } from "twin.macro"

// Utils
import { SlideProps } from "."
import { modalStyles } from "../utils/modalStyles"

// Components
import CloseIcon from "../svgs/closeIcon"
import Container from "../components/container"
import IconBrakes from "../icons/iconBrakes"
import IconDrivelines from "../icons/iconDrivelines"
import IconPetrolDiesel from "../icons/iconPetrolDiesel"
import IconSafety from "../icons/iconSafety"
import IconSuspension from "../icons/iconSuspension"
import IconTools from "../icons/iconTools"
import IconTyres from "../icons/iconTyres"
import IconEssential from "../icons/iconEssential"
import LearnDetail from "../components/learnDetail"
import NextPageButton from "../components/nextPageButton"
import SlideSection from "../components/slideSection"
import NextPageContainer from "../components/nextPageContainer"

const MediumThreeQuarters = styled.div`
@media (max-width: 768px) {
  width: 70vw;
}
  ${tw` flex flex-col items-center justify-center`}
`

const MediumOneQuarter = styled.div`
  width: 15% ${tw`lg:w-2/6 flex flex-col items-end justify-center`};
`

const LearnSlide: React.SFC<SlideProps> = ({
  slideVisible,
  nextButtonClicked,
}) => {
  const [topicIndex, setTopicIndex] = useState<number>(-1)

  // const isSmall = useMediaQuery({ query: "(max-width: 767px)" })

  return (
    <SlideSection autoHeightResponsive>
      <div css={[tw`flex flex-col justify-center items-center`]}>
        <Container>
        <Columns css={[css`
      @media (max-width: 768px) {
        flex-direction: column-reverse;
      }`]}>
            <SmallOneQuarter></SmallOneQuarter>
            <MediumOneQuarter>
              <TextQuarter css={[
                tw`mt-6`
              ]}>
                Trucking is an essential service, transporting 90% of <span css={[css`word-break: keep-all;`]}>New Zealand’s</span> total freight by weight.
              </TextQuarter>
            </MediumOneQuarter>
            <MediumThreeQuarters>
                <IconEssential />
            </MediumThreeQuarters>
          </Columns>
        </Container>
        <NextPageContainer>
          <NextPageButton
            onClick={nextButtonClicked}
            label=""
          />
        </NextPageContainer>
      </div>
    </SlideSection>
  )
}

const LargeForceWrap = () => (
  <div
    css={[
      css`
        flex-basis: 100%;
        height: 0;
      `,
      tw`hidden lg:block`,
    ]}
  />
)

const Columns = styled.div`
  ${tw`flex flex-col lg:flex-row items-center justify-center w-full`}
`

const LargeThreeQuarters = styled.div`
  ${tw`lg:w-3/6 flex flex-col items-center justify-center`}
`

const LargeOneQuarter = styled.div`
  ${tw`lg:w-2/6 flex flex-col items-center justify-center`}
`

const TextQuarter = styled.div`
  font-family: Interstate; font-size: 26px; line-height: 31.2px; font-weight: 300; letter-spacing: 0.41px;
  @media (max-width: 768px) {
    font-size: 22px; 
    line-height: 26px;
    width: 76vw;
  }
  ${tw`flex flex-col flex-wrap flex-row text-center justify-center`}
`

const SmallOneQuarter = styled.div`
  ${tw`lg:w-1/12 flex flex-col items-center justify-center`}
`


const Instructions = styled.p`
  font-family: Interstate;
  font-size: 26px;
  line-height: 31.2px;
  ${tw`w-64 text-center mb-6`}
`

const TitleWrapper = styled.div`
  ${tw`flex flex-col items-center justify-center`}
`

const Topics = styled.div`
  ${tw`flex flex-col flex-wrap flex-row justify-center`}
`

const Topic = styled.div`
  ${tw`flex flex-col items-center w-1/2 md:w-1/3 mb-12 px-8`}
`

const TopicDescription = styled.p`
  max-width: 9rem;
  ${tw` text-sm text-center mt-3 whitespace-pre-line`}
`
export default LearnSlide
